import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HomeService } from '../services/homeservice';
import { IHome } from '../sidenav/helper';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-masterpolicies',
  templateUrl: './masterpolicies.component.html',
  styleUrls: ['./masterpolicies.component.css']
})
export class MasterpoliciesComponent implements OnInit {
  @Output() openDetailTab = new EventEmitter();
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @Input() IsHomeClicked: boolean = false;
  masterpolicies: IHome[] = [];
  searchTerm: string = '';
  filteredData: IHome[] = [];
  sortingColumn: string = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  isSearching: boolean = false;
  dataSource!: MatTableDataSource<IHome>;
  totalItems: number = 0;
  currentPageIndex: number = 0;
  pageSize: number = 45;
  pageSizeOptions: number[] = [45, 90, 135];
  isHidePageSize: boolean = true;
  showFirstLastButtons = true;
  isLoading: boolean = false;
  currentPage: number = 0;
  columnsToDisplay: string[] = [
    'accountName',
    'policyNumber',
    'policyType',
    'policyStatus',
    'contractNumber',
    'effectiveDate',
    'expirationDate',
    'notes'

  ]
  data: any[] = [];
  private refreshSubscription!: Subscription;
  masterPolicyData: any;
  response: any;

  constructor(private service: HomeService, public dynamicTabsService: DynamicTabsService) {
    this.dataSource = new MatTableDataSource<IHome>([]);

  }
  ngOnInit(): void {
    this.getPolicies();


    this.dynamicTabsService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabsService.selectedTab == 'Master Policies')
        this.refresh();
    })

    this.loadTableData();
  }

  ngAfterViewInit() {
    this.paginator.pageSize = 45;
    this.checkRowsPerPage();
  }
  //event listener for searching
  @HostListener('document:keyup.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.search();
    }
  }
  //checking number of rows per page
  checkRowsPerPage() {
    if (this.paginator) {
      const rowsPerPage = this.paginator.pageSize;
      // console.log(`Number of rows per page:${rowsPerPage}`);
    }
  }

  loadTableData() {
    this.isLoading = true;
    this.getPolicies();
  }

  refresh() {
    if (this.dynamicTabsService.selectedTabData.id == -8) {
      this.isLoading = true;
      this.getPolicies();
      this.clearSearch();
      // console.log("Masterpolicies component refreshed");
    }
  }

  sendIdtochild(policy: any) {
    this.openDetailTab.emit({ id: policy.accountID, label: policy.accountName, type: 'association' });
    // console.log(policy.id);
    // childcomp : ev.iD
  }
  openPolicy(policy: any) {
    this.openDetailTab.emit({ id: policy.id, label: policy.policyNumber + '-policy', type: 'policy' });
    // console.log(policy.id);
  }

  getPolicies(): void {
    this.service.getMasterPolicyData(0).subscribe((res: IHome[]) => {
      this.masterpolicies = res;
      this.filteredData = this.masterpolicies;
      this.totalItems = this.filteredData.length;
      this.applyPagination();
      this.isLoading = false;
      res.sort((a, b) => {
        const insuredA = a.accountName?.toLowerCase();
        const insuredB = b.accountName?.toLowerCase();
        // console.log("Insured sorted ascending while loading masterpolicies");
        if (isNaN(Number(insuredA)) && isNaN(Number(insuredB))) {
          return insuredA?.localeCompare(insuredB);
        }
        else if (!isNaN(Number(insuredA)) && !isNaN(Number(insuredB))) {
          return Number(insuredA) - Number(insuredB);
        }
        else {
          return isNaN(Number(insuredA)) ? 1 : -1;
        }
      });
      this.dataSource.data = res;
      this.dataSource.sort = this.sort;

    })
  }
  applyFilter(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    const searchValue = this.searchTerm.trim().toLowerCase();
    this.filteredData = this.masterpolicies.filter((item) => {
      const searchFields = [item.accountName, item.policyNumber, item.policyType, item.policyStatus, item.contractNumber, item.effectiveDate, item.expirationDate];
      return searchFields.some((field) => String(field).toLowerCase().includes(searchValue));
    });
    this.totalItems = this.filteredData.length;
    this.isSearching = searchValue != '';
    this.applyPagination();
  }
  search(): void {
    this.applyFilter();
  }
  onPageChange(event: any): void {
    this.currentPageIndex = event.pageIndex;
    this.pageSize = 45;
    this.applyPagination();
  }

  applyPagination(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource.data = this.filteredData.slice(startIndex, endIndex);
  }

  pageChanged(page: number): void {
    this.currentPage = page;
    this.filterData();
  }
  filterData(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.filteredData = this.dataSource.data.slice(startIndex, endIndex);
  }

  clearSearch(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    this.searchTerm = '';
    this.isSearching = false;
    this.filteredData = this.masterpolicies;
    this.totalItems = this.masterpolicies.length;

    this.applyPagination();
  }
  getTotalPages(): number {
    return Math.ceil(this.filteredData.length / this.pageSize);
  }

  sortData(column: keyof IHome) {
    if (this.sortingColumn === column) {

      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    }
    else {
      this.sortingColumn = column;
      this.sortOrder = 'asc';
    }
    this.masterpolicies.sort((a, b) => {
      const valueA = (a[column] || '').toString();
      const valueB = (b[column] || '').toString();
      //compare mixed-case values
      if (valueA.toLowerCase() < valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? -1 : 1;
      }

      else if (valueA.toLowerCase() > valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? 1 : -1;
      }

      //Handle empty values
      if (valueA === '' && valueB === '') {
        return 0;
      } else if (valueA === '') {
        return -1;
      } else if (valueB === '') {
        return 1;
      }
      return 0;

    });
    this.applyPagination();
  }


}

